import betslip from '@gin-betting/betslip';
import { createSelector } from 'reselect';

import { useMemoSelector } from 'hooks';

const {
    selectors: { selectBetslipBetWithStatus },
} = betslip;

interface Input {
    betslipBetId: string;
}

type Output = {
    betslipBet: NonNullable<ReturnType<typeof selectBetslipBetWithStatus>>;
} | null;

const selectProps = createSelector(selectBetslipBetWithStatus, betslipBet => {
    if (!betslipBet) return null;

    return { betslipBet };
});

const useValidBetslipProps = ({ betslipBetId }: Input): Output => {
    return useMemoSelector(selectProps, { betslipBetId });
};

export default useValidBetslipProps;
